import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { object, string } from "yup";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import { StyledFormField } from "@/components/uielements/form-fields/styles";
import { Form, Input } from "@/components/uielements/formik";
import { StyledPrimaryButton } from "@/components/uielements/primaryButton/styles";
import { LAYOUT } from "@/constants/styles";
import { VALIDATION_STRINGS } from "@/constants/validation";
import authActions from "@/redux/auth/actions";
import { authSliceSelector } from "@/redux/auth/reducer";

// Validation schema for the barcode submission form.
const forgotPasswordSchema = object({
  // The email must be valid and present.
  email: string()
    .email(VALIDATION_STRINGS.EMAIL)
    .required(VALIDATION_STRINGS.REQUIRED),
});

/**
 * Form to send an email with a link to reset a user's password.
 *
 * @TODO during Stitches overhaul, inline the SubmitButton style override.
 */
export function ForgotPasswordForm() {
  const dispatch = useDispatch();
  const { loading } = useSelector(authSliceSelector);

  return (
    <Formik
      validateOnBlur
      validateOnChange={false}
      onSubmit={({ email }, { resetForm }) => {
        // Dispatch the action then reset the form.
        dispatch(authActions.forgotPassword(email));
        resetForm();
      }}
      initialValues={{ email: "" }}
      validationSchema={forgotPasswordSchema}
    >
      {({ dirty, isValid }) => (
        <Form>
          <StyledFormField>
            <Input
              id="email"
              name="email"
              type="email"
              label="Email"
              autoFocus
            />
          </StyledFormField>
          <SubmitButton
            disabled={!dirty || !isValid}
            submitting={loading}
            type="submit"
            buttonTheme="secondary"
          >
            <StringAccessor
              accessor={
                loading
                  ? "forgot_password.submit_cta_loading"
                  : "forgot_password.submit_cta"
              }
            />
          </SubmitButton>
        </Form>
      )}
    </Formik>
  );
}

const SubmitButton = styled(StyledPrimaryButton)`
  margin-left: ${LAYOUT.GUTTER}px;
  @media (max-width: 767px) {
    margin: 0 auto;
  }
`;
